import React from "react";
import { Routes, Route, HashRouter } from 'react-router-dom'
import MenuTabs from './MenuTabs/MenuTabs'
import Organizations from "./Organizations/Organizations";
import { GroupDashboardProvider } from "./GroupDashboardContext";

const GroupDashboardContent = ( props:any ) => {

  const teamOptionsData = JSON.parse(props['data-team-options'] || '{}')
  const siteOptionsData = JSON.parse(props['data-site-options'] || '{}')
  const siteFiltersData = JSON.parse(props['data-site-filters'] || '{}')
  
  const orgBreadcrumbs = [
    { 
      icon: 'home',
      label: siteFiltersData.woo.teams.plural_label, 
      link: '/'
    }
  ]

  const menuTabsRoutes = [
    { path: "/organization/:team_id", type: "home" },
    { path: "/organization/:team_id/members", type: "members" },
    { path: "/organization/:team_id/licenses", type: "licenses" },
    { path: "/organization/:team_id/member-home", type: "member-home" },
    { path: "/organization/:team_id/manage", type: "manage" },
    { path: "/organization/:team_id/reporting-group", type: "reporting-group" },
    { path: "/organization/:team_id/team-settings", type: "team-settings" },
  ]

  const menuTabsProps = {
    'breadcrumbs': orgBreadcrumbs,
    'teamOptionsData': teamOptionsData,
    'siteOptionsData': siteOptionsData,
    'siteFiltersData': siteFiltersData,
    'getTeamType': (teamId) => {
      const organizationData = JSON.parse( props['data-organizations'] ) ?? []
      const currentOrganization = organizationData.find((organization) => organization.teamId == teamId)
      return currentOrganization.teamType
    }
  }

  return(
    <div className="msync-organization-dashboard">
      <HashRouter>
        <GroupDashboardProvider>
          <Routes>
            <Route path="/" element={<Organizations {...props} breadcrumbs={ orgBreadcrumbs } />} />
            { menuTabsRoutes.map(({ path, type }) => (
              <Route
                key={path}
                path={path}
                element={<MenuTabs type={type} {...menuTabsProps} />}
              />
            ))}
          </Routes>
        </GroupDashboardProvider>
      </HashRouter> 
    </div>
  )

}

export default GroupDashboardContent
